(function () {
  const HYDROGEN_CART_ENDPOINT = 'https://wholesale-account.rishi-tea.com/api/cart/add';
  const HYDROGEN_CART_COUNT_ENDPOINT = 'https://wholesale-account.rishi-tea.com/api/cart/count';
  const HYDROGEN_CUSTOMER_VALIDATE_ENDPOINT = 'https://wholesale-account.rishi-tea.com/api/customer/validate';

  function normalizeVariantId(raw) {
    const id = (raw || '').toString().trim();
    if (!id) return null;
    return id.startsWith('gid://')
      ? id
      : `gid://shopify/ProductVariant/${id}`;
  }

  function updateHydrogenCartCount(newCount) {
    const el =
      document.getElementById('hydrogen-cart-count') ||
      document.querySelector('[data-hydrogen-cart-count]');

    if (!el) {
      console.warn('[Hydrogen Cart] Cart count element not found');
      return;
    }

    const previous = Number(el.dataset.oldCount || el.textContent || 0);
    const count = Number(newCount || 0);

    el.textContent = count;
    el.dataset.oldCount = count;

    if (count !== previous) {
      el.classList.add('cart-bounce');
      setTimeout(() => el.classList.remove('cart-bounce'), 300);
    }
  }

  async function loadHydrogenCartCount() {
    try {
      const response = await fetch(HYDROGEN_CART_COUNT_ENDPOINT, {
        method: 'GET',
        credentials: 'include',
      });

      if (!response.ok) {
        console.warn('[Hydrogen Cart] Count endpoint returned status', response.status);
        return;
      }

      const text = await response.text();
      let data = null;
      try {
        data = text ? JSON.parse(text) : null;
      } catch (e) {
        console.warn('[Hydrogen Cart] Count response is not valid JSON:', text);
      }

      const count = Number(data?.count ?? 0);
      updateHydrogenCartCount(count);
    } catch (error) {
      console.error('[Hydrogen Cart] Error loading cart count', error);
    }
  }

  async function addToHydrogenCart(lines) {
    try {
      const response = await fetch(HYDROGEN_CART_ENDPOINT, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({ lines }),
      });

      console.log('[Hydrogen Cart] Response status:', response.status);

      const text = await response.text();
      let data = null;
      try {
        data = text ? JSON.parse(text) : null;
      } catch (e) {
        console.warn('[Hydrogen Cart] Response is not valid JSON:', text);
      }

      if (!response.ok) {
        console.error(
          '[Hydrogen Cart] Failed to add to Storefront cart:',
          response.status,
          data || text,
        );
        return null;
      }

      console.log(
        '[Hydrogen Cart] Storefront cart updated:',
        data?.cart || data,
      );

      try {
        const count = data?.cart?.totalQuantity;
        if (typeof count === 'number') {
          updateHydrogenCartCount(count);
        }
      } catch (e) {
        console.warn('[Hydrogen Cart] Unable to read totalQuantity from response', e);
      }

      return data;
    } catch (error) {
      console.error(
        '[Hydrogen Cart] Network or CORS error adding to cart:',
        error,
      );
      return null;
    }
  }

  async function handlePdpAtcButtonClick(button) {
    const form = button.closest('form');
    if (!form) {
      console.warn(
        '[Hydrogen Cart] PDP: No parent form found for ATC button',
        button,
      );
      return null;
    }

    const variantInput = form.querySelector('input[name="id"]');
    const rawVariantId = variantInput ? variantInput.value : null;
    const variantId = normalizeVariantId(rawVariantId);

    const quantityInput = form.querySelector('input[type="number"]');
    const quantity = Number(
      quantityInput && quantityInput.value ? quantityInput.value : 1,
    );

    if (!variantId) {
      console.warn('[Hydrogen Cart] PDP: No valid variant id found', {
        rawVariantId,
      });
      return null;
    }

    console.log(
      '[Hydrogen Cart] PDP ATC: Variant:',
      variantId,
      'Qty:',
      quantity,
    );

    const lines = [
      {
        merchandiseId: variantId,
        quantity,
      },
    ];

    const data = await addToHydrogenCart(lines);
    return data;
  }

  async function handleCollectionAtcButtonClick(button) {
    const rawVariantId = button.dataset.variantId;
    const variantId = normalizeVariantId(rawVariantId);
    const quantity = Number(button.dataset.quantity || '1');
 console.log('[Hydrogen Cart] Raw variant id attribute:', rawVariantId, 'from button:', button);
    if (!variantId) {
      console.warn(
        '[Hydrogen Cart] Collection: No valid data-variant-id on button',
        { rawVariantId, button },
      );
      return null;
    }

    const inventoryAttr = button.dataset.inventory;
    if (inventoryAttr !== undefined && inventoryAttr !== null && inventoryAttr !== '') {
      const inventory = Number(inventoryAttr);
      if (!Number.isNaN(inventory) && inventory <= 0) {
        console.log(
          '[Hydrogen Cart] Collection ATC: Variant out of stock (from data-inventory), skipping API call',
          { variantId, inventory },
        );
        return null;
      }
    }
console.log('[Hydrogen Cart] Raw variant id attribute:', rawVariantId);
    console.log(
    '[Hydrogen Cart] Collection ATC: Variant:',
    variantId,
    'Qty:',
    quantity,
  );

    const lines = [
      {
        merchandiseId: variantId,
        quantity,
      },
    ];

    const data = await addToHydrogenCart(lines);
    return data;
  }

  async function withButtonLockAndLabel(button, handler, options) {
    const config = Object.assign(
      {
        successLabel: 'Added to cart',
        failureLabel: 'Out of stock',
        revertDelayMs: 2000,
      },
      options || {},
    );

    if (button.dataset.hydrogenLocked === 'true' || button.disabled) {
      console.log('[Hydrogen Cart] ATC click ignored (locked)', button);
      return;
    }

    const previousDisabledState = button.disabled;
    const originalText = button.textContent;

    button.dataset.hydrogenLocked = 'true';
    button.disabled = true;

    let labelUsed = null;

    try {
      const result = await handler(button);

      if (result) {
        button.textContent = config.successLabel;
        labelUsed = config.successLabel;
      } else {
        button.textContent = config.failureLabel;
        labelUsed = config.failureLabel;
      }
    } catch (error) {
      console.error('[Hydrogen Cart] Error during ATC handler', error);
      button.textContent = config.failureLabel;
      labelUsed = config.failureLabel;
    } finally {
      button.disabled = previousDisabledState;
      button.dataset.hydrogenLocked = 'false';

      if (labelUsed) {
        setTimeout(function () {
          if (button.textContent === labelUsed) {
            button.textContent = originalText;
          }
        }, config.revertDelayMs);
      }
    }
  }

  async function withButtonLockAndInnerLabel(button, handler, options) {
    const config = Object.assign(
      {
        successLabel: 'Added to cart',
        failureLabel: 'Out of stock',
        revertDelayMs: 2000,
      },
      options || {},
    );

    if (button.dataset.hydrogenLocked === 'true' || button.disabled) {
      console.log('[Hydrogen Cart] ATC click ignored (locked)', button);
      return;
    }

    const labelEl = button.querySelector('[data-atc-label]');
    const originalLabelText = labelEl ? labelEl.textContent : button.textContent;
    const previousDisabledState = button.disabled;

    button.dataset.hydrogenLocked = 'true';
    button.disabled = true;

    let labelUsed = null;

    function setLabel(text) {
      if (labelEl) {
        labelEl.textContent = text;
      } else {
        button.textContent = text;
      }
    }

    try {
      const result = await handler(button);

      if (result) {
        setLabel(config.successLabel);
        labelUsed = config.successLabel;
      } else {
        setLabel(config.failureLabel);
        labelUsed = config.failureLabel;
      }
    } catch (error) {
      console.error('[Hydrogen Cart] Error during ATC handler', error);
      setLabel(config.failureLabel);
      labelUsed = config.failureLabel;
    } finally {
      button.disabled = previousDisabledState;
      button.dataset.hydrogenLocked = 'false';

      if (labelUsed) {
        setTimeout(function () {
          if (labelEl) {
            if (labelEl.textContent === labelUsed) {
              labelEl.textContent = originalLabelText;
            }
          } else if (button.textContent === labelUsed) {
            button.textContent = originalLabelText;
          }
        }, config.revertDelayMs);
      }
    }
  }

  function attachPdpInterceptors(root) {
    const forms = root.querySelectorAll('form[action*="/cart/add"]');
    if (!forms.length) return;

    console.log(
      '[Hydrogen Cart] PDP: Delegated handler active for /cart/add forms:',
      forms.length,
    );
  }

  function attachCollectionInterceptors(root) {
    const buttons = root.querySelectorAll(
      'button.button__secondary[data-variant-id], button.quick-add[data-variant-id]'
    );
    if (!buttons.length) return;

    console.log(
      '[Hydrogen Cart] Collection: Delegated handler active for',
      buttons.length,
      'buttons in',
      root
    );
  }

  function attachAllInterceptors(root) {
    attachPdpInterceptors(root);
    attachCollectionInterceptors(root);
  }

  async function validateCustomer(email) {
    try {
      const response = await fetch(`${HYDROGEN_CUSTOMER_VALIDATE_ENDPOINT}?email=${email}`, {
        method: 'GET',
        credentials: 'include',
      });
      if (!response.ok) {
        console.warn('[Hydrogen Customer] Validate endpoint returned status', response.status);
        return;
      }
      const text = await response.text();
      let data = null;
      try {
        data = text ? JSON.parse(text) : null;
      } catch (e) {
        console.warn('[Hydrogen Customer] Response is not valid JSON:', text);
      }
      return data;
    }
    catch (error) {
      console.error('[Hydrogen Customer] Error loading customer validate', error);
      return null;
    }
  }

  function attachRegisterValidation() {
    if (window.location.pathname !== '/pages/register') {
      return;
    }
    var formContainer = document.querySelector('[data-cf-form]');
    if (!formContainer) {
      return;
    }
    function tryBindEmailListener(root) {
      var emailField =
        root.querySelector('input[type="email"]') ||
        root.querySelector('input[name="email"]') ||
        root.querySelector('input[name*="[email]"]');

      if (!emailField || emailField.__hydrogenEmailBound) {
        return false;
      }

      emailField.__hydrogenEmailBound = true;

      emailField.addEventListener('blur', async function (e) {
        var email = e.target.value;
        if (!email) return;
        let data = await validateCustomer(email);
        if (data !== null && data.emailExists) {
          let nextButton = root.querySelector('.cf-next-step.cf-button');
          nextButton.setAttribute('disabled', 'disabled');
          emailField.parentElement.setAttribute('data-cf-invalid', 'true');
          emailField.insertAdjacentHTML(
            'afterend',
            `<div class="error-inline-content">
              <p>This email is already registered.</p>
              <p><a href="/pages/login" class="button__tertiary">Log in</a> instead.</p>
             </div>`
          );
        }
      });

      return true;
    }

    if (tryBindEmailListener(formContainer)) {
      return;
    }

    var observer = new MutationObserver(function (mutations, obs) {
      if (tryBindEmailListener(formContainer)) {
        obs.disconnect();
      }
    });

    observer.observe(formContainer, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('button.button__atc[type="button"]');
    if (!button) return;

    const form = button.closest('form[action*="/cart/add"]');
    if (!form) return;

    event.preventDefault();
    console.log('[Hydrogen Cart] PDP: ATC click (delegated)', button);

    withButtonLockAndLabel(button, handlePdpAtcButtonClick);
  });

document.addEventListener(
  'click',
  function (event) {
    console.log('[Hydrogen Cart] document click (capture)', event.target);

    const button = event.target.closest(
      'button.button__secondary[data-variant-id], button.quick-add[data-variant-id]'
    );
    if (!button) {
      return;
    }

    console.log('[Hydrogen Cart] Collection: ATC click (delegated)', button);

    const isQuickAdd = button.classList.contains('quick-add');

    event.preventDefault();

    if (isQuickAdd) {
      setTimeout(() => {
        withButtonLockAndInnerLabel(button, handleCollectionAtcButtonClick);
      }, 0);
    } else {
      withButtonLockAndLabel(button, handleCollectionAtcButtonClick);
    }
  },
  true
);
  document.addEventListener('DOMContentLoaded', function () {
    attachAllInterceptors(document);
    loadHydrogenCartCount();
    attachRegisterValidation();
  });

  document.addEventListener('shopify:section:load', function (event) {
    const container = event.target || event.detail?.section;
    if (container) {
      attachAllInterceptors(container);
    }
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      loadHydrogenCartCount();
    }
  });
})();